// extracted by mini-css-extract-plugin
module.exports = {"powerocean":"Powerocean_powerocean__Mpp45"};